import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#1976d2',  // Keep this for primary actions if needed
        },
        secondary: {
            main: '#21CBF3',
        },
    },
    components: {
        MuiAppBar: {
            styleOverrides: {
                root: {
                    background: '#292929',
                    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.03)',
                    '& .MuiIconButton-root': {
                        color: 'rgba(255, 255, 255, 0.9)',
                    },
                    '& .MuiTypography-root': {
                        color: 'rgba(255, 255, 255, 0.95)',
                    },
                    '& .MuiTypography-subtitle1': {
                        color: 'rgba(255, 255, 255, 0.7)',
                    },
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    height: '30px',
                    borderRadius: '4px',
                    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.03)',
                    '&:hover': {
                        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
                    },
                },
                outlined: {
                    borderColor: '#e0e0e0',
                    height: '30px',
                    color: '#666',
                    '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        borderColor: '#bdbdbd',
                    },
                },
                contained: {
                    // Default look for contained buttons
                    background: '#8146D1',
                    height: '30px',
                    color: '#fff',
                    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                    '&:hover': {
                        background: '#383838',
                    },
                },
            },
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    padding: '8px',
                    borderRadius: '4px',
                },
            },
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    borderColor: 'rgba(0, 0, 0, 0.06)',
                },
            },
        },
    },
});

export default theme;